<template>
  <div>
    <el-form class="searchForm mb20" label-position="top">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.vendorAlias')">
            <el-select v-model="searchForm.vendorName" filterable clearable>
              <el-option v-for="item in storeNameList" :label="item" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.vendorName')">
            <el-select v-model="searchForm.vendorName" filterable clearable>
              <el-option v-for="item in storeNameList" :label="item" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.vendorType')">
            <el-select v-model="searchForm.vendorType" clearable>
              <el-option v-for="item in vendorTypeList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('common.country')">
            <el-select v-model="searchForm.addressCountryId" filterable clearable>
              <el-option v-for="item in countryList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.storeBuildStatus')">
            <el-select v-model="searchForm.auditStatus" clearable>
              <el-option v-for="item in createVendorStatus" :label="item.dictValue" :value="item.dictCode" :key="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.vendorCurrency')">
            <el-select v-model="searchForm.originalPriceType" clearable>
              <el-option v-for="item in unitList" :label="item.label" :value="item.value" :key="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.vendorRegion')">
            <el-select v-model="searchForm.businessRegionId" clearable>
              <el-option v-for="(item, idx) in businessRegionList" :key="idx" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.imRepresentative')">
            <el-select v-model="searchForm.boutiqueSaleConcatId" filterable clearable>
              <el-option v-for="item in boutiqueBdList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.imAssistantRepresentative')">
            <el-select v-model="searchForm.boutiqueAssistantId" filterable clearable>
              <el-option v-for="item in boutiqueBdList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <div class="form-btn">
            <el-button type="primary" @click="searchTableData(true)">{{ $t('common.search') }}</el-button>
            <el-button @click="resetSearchForm">{{ $t('common.reset') }}</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <div class="tr mb20">
      <el-button type="primary" v-if="createStoreBtn" @click="$router.push({ path: '/crm/cn/create' })">{{ $t('crm.applyCreateStore') }}</el-button>
    </div>

    <el-table :data="tableData" ref="searchTable" :header-cell-style="{backgroundColor: '#f0f0f0'}" border v-loading="loading">
      <el-table-column :label="$t('crm.vendorName')" prop="vendorName">
        <template slot-scope="scope">
          <template v-if="showVendorName">
            {{ scope.row.vendorName }}
            <p>/</p>
            {{ scope.row.vendorNameAlias }}
          </template>
          <template v-else>
            {{ scope.row.vendorNameAlias }}
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('crm.vendorType')" prop="vendorType">
        <template slot-scope="scope">
            {{scope.row.vendorType}}{{ scope.row.wholesaleType == 1 ? "（现货货单）" : scope.row.wholesaleType == 4 ? "（品牌补货）" : scope.row.wholesaleType == 5 ? "（期货预售）" : "" }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.country')" prop="addressCountryName"></el-table-column>
      <el-table-column :label="$t('crm.vendorCurrency')" prop="originalPriceUnit"></el-table-column>
      <el-table-column :label="$t('crm.pricingConnectivityMethod')" prop="supplyPriceMethod"></el-table-column>
      <el-table-column :label="$t('crm.vendorRegion')" prop="businessRegion"></el-table-column>
      <el-table-column :label="$t('crm.imRepresentative')" prop="boutiqueBdId">
        <template slot-scope="scope">
          {{ boutiqueBdMap[scope.row.boutiqueBdId] }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('crm.imAssistantRepresentative')" prop="boutiqueAssistantId">
        <template slot-scope="scope">
          {{ boutiqueBdMap[scope.row.boutiqueAssistantId] }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('crm.storeBuildStatus')">
        <template slot-scope="scope">
          <p>{{ createVendorStatusMap[scope.row.auditStatus] }}</p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('crm.storeReviewer')">
        <template slot-scope="scope">
          {{ approvalUserMap[scope.row.approvalUserId] }}
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('crm.preSaleAvailablity')" prop="isPreSale"></el-table-column> -->
      <el-table-column :label="$t('common.action')" width="260">
        <template slot-scope="scope">
          <el-button type="text" size="small" v-if="auditStoreBtn && scope.row.auditStatus == 0" @click="showAudit(scope.row.crmPrepareVendorId)">{{ $t('crm.auditStore') }}</el-button>
          <el-button type="text" size="small" v-if="createStoreBtn && (scope.row.auditStatus == 1 || scope.row.auditStatus == 2)" @click="showCreateStore(scope.row.crmPrepareVendorId)">{{ $t('crm.viewVendorInfo') }}</el-button>
          <el-button type="text" size="small" v-if="techInfoBtn && scope.row.auditStatus == 1" @click="goTech(scope.row)">{{ $t('crm.setTechInfo') }}</el-button>
          <el-button type="text" size="small" v-if="createStoreBtn && scope.row.auditStatus == 2" @click="deleteItem(scope.row.crmPrepareVendorId)">{{ $t('common.remove') }}</el-button>
          <el-button type="text" size="small" v-if="createStoreBtn && scope.row.auditStatus == 2" @click="reEditAudit(scope.row.crmPrepareVendorId)">{{ $t('crm.reApplyBuildStore') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="tr mt10">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="searchForm.currentPage"
        small
        :page-sizes="[10, 25, 50, 100]"
        :page-size="searchForm.pageSize"
        layout="total,sizes,prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  getCreatingVendorList as getTableData,
  deleteVendor,
} from '../api';

export default {
  props: {
    vendorList: Array,
    systemList: Array,
    vendorTypeList: Array,
    countryList: Array,
    vendorStatusList: Array,
    unitList: Array,
    vendorProductSourceTypeList: Array,
    supplyPriceMethodList: Array,
    businessRegionList: Array,
    boutiqueBdList: Array,
    boutiqueBdMap: Object,
    approvalUserList: Array,
    approvalUserMap: Object,
    createVendorStatus: Array,
    createVendorStatusMap: Object,
    storeNameList: Array,
  },
  data() {
    return {
      searchForm: {
        vendorName: null,
        vendorType: null,
        addressCountryId: null,
        auditStatus: null,
        originalPriceType: null,
        businessRegionId: null,
        boutiqueSaleConcatId: null,
        boutiqueAssistantId: null,
        currentPage: 1,
        pageSize: 25,
      },
      loading: false,
      tableData: [],
      totalCount: 0,
    };
  },
  computed: mapState({
    createStoreBtn: (state) => state.app.menuMap['商家CRM-hide-申请创建新店'],
    techInfoBtn: (state) => state.app.menuMap['商家CRM-hide-技术信息配置'],
    auditStoreBtn: (state) => state.app.menuMap['商家CRM-hide-审核建店信息'],
    showVendorName: (state) => state.app.menuMap['商家CRM-hide-查看买手店名称'],
  }),
  mounted() {
    this.getTableData();
  },
  methods: {
    goTech(row){ //跳转编辑技术
      let {crmPrepareVendorId,addressCountryName,vendorTypeId,productSourceTypeId,supplyPriceMethod,wholesaleOneVendorId,marketplaceVendorId} = row;
      this.$router.push({
        path:"/crm/cn/edittechnology",
        query:{crmPrepareVendorId,addressCountryName,vendorTypeId,productSourceTypeId,supplyPriceMethod,wholesaleOneVendorId,marketplaceVendorId}
      })
    },
    searchTableData() {
      this.searchForm.currentPage = 1;
      this.getTableData();
    },
    resetSearchForm() {
      this.searchForm.vendorName = null;
      this.searchForm.vendorType = null;
      this.searchForm.addressCountryId = null;
      this.searchForm.auditStatus = null;
      this.searchForm.originalPriceType = null;
      this.searchForm.businessRegionId = null;
      this.searchForm.boutiqueSaleConcatId = null;
      this.searchForm.boutiqueAssistantId = null;
      this.searchForm.currentPage = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getTableData(this.searchForm).then(res => {
        if (res.data && res.data.success) {
          this.tableData = res.data.data.list;
          this.totalCount = res.data.data.total;
        }
        this.loading = false;
      });
    },
    handleCurrentChange(currentPage) {
      this.searchForm.currentPage = currentPage;
      this.getTableData();
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.getTableData();
    },
    showAudit(vendorId) {
      this.$router.push({ path: `/crm/cn/store/audit/${vendorId}` })
    },
    reEditAudit(vendorId) {
      this.$router.push({ path: `/crm/cn/store/edit/${vendorId}` })
    },
    showCreateStore(vendorId) {
      this.$router.push({ path: `/crm/cn/store/show/${vendorId}` })
    },
    deleteItem(vendorId) {
      this.$confirm(this.$t('common.confirmDelete'), this.$t('common.message'), {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning',
      }).then(() => {
        deleteVendor({
          crmPrepareVendorId: vendorId,
        }).then(res => {
          if (res.data && res.data.success) {
            this.getTableData();
          } else {
            this.$message.error(res.data.message || this.$t('common.systemError'));
          }
        })
      }).catch(() => {});
    }
  },
};
</script>

<style lang="less" scoped>
.form-btn {
  margin-top: 40px;
}
.mt10 {
  margin-top: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.tr {
  text-align: right;
}
.f12 {
  font-size: 12px;
}
.red {
  color: red;
}
</style>
<style lang="less">
.searchForm {
  .el-form-item__label {
    padding: 0;
  }

  .el-form-item {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
